export default "__VITE_ASSET__z$BJd_oF__"